import { apiGet, apiPost } from "./api";

/** Mirrors the backend NotificationType enum. */
export type NotificationType =
    | "CONTRIBUTOR_REQUEST"
    | "CONTRIBUTOR_REQUEST_APPROVED"
    | "CONTRIBUTOR_REQUEST_DENIED"
    | "PROMOTED_TO_CONTRIBUTOR";

export interface NotificationDTO {
    id: number;
    type: NotificationType;
    playlistId: number;
    playlistName?: string | null;
    actorUserId: number;
    actorUsername?: string | null;
    /** Counts toward the badge until resolved. Only CONTRIBUTOR_REQUEST sets this. */
    actionRequired: boolean;
    read: boolean;
    createdAt: string;
}

export interface NotificationsResponse {
    /** The red badge number: notifications still waiting on a decision, not unread mail. */
    actionableCount: number;
    items: NotificationDTO[];
}

export function fetchNotifications(): Promise<NotificationsResponse> {
    return apiGet<NotificationsResponse>("/v1/notifications");
}

/**
 * Marks an informational notification read. Requests are never marked read this way -
 * approving or denying one is what settles it.
 */
export function markNotificationRead(id: number): Promise<{ read: boolean }> {
    return apiPost<{ read: boolean }>(`/v1/notifications/${id}/read`);
}

/**
 * Fired after acting on a request so the bell recounts immediately instead of waiting
 * out the poll interval. Same decoupling as PLAYLISTS_CHANGED_EVENT: the bell lives in
 * the header and the dialogs that resolve requests are elsewhere in the tree.
 */
export const NOTIFICATIONS_CHANGED_EVENT = "shufl:notifications-changed";

export function notifyNotificationsChanged(): void {
    window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED_EVENT));
}
